module.exports = __webpack_public_path__ + "static/assets/409a833317adc76a00df655bd87ef43f.png";